import { Component } from 'base/js/aem';
import { createApp } from 'vue';
import EventsTemplate from './Events.vue';

class Events extends Component {
    init() {
        this.showEvents();
    }
    showEvents() {
        const eventPlaceHolder = this.element.querySelector('[data-events-json]');
        const eventDetailsLabel = this.props.cmpEventDetails;
        const isFiltered = eventPlaceHolder.dataset.isFiltered === 'true';
        if (eventPlaceHolder) {
            const eventsData = JSON.parse(eventPlaceHolder.dataset.eventsJson);
            const props = {
                events: eventsData,
                isFiltered: isFiltered
            };
            const eventsComponent = createApp(EventsTemplate, props);
            eventsComponent.mount(eventPlaceHolder);
        }
    }
}

export { Events };
